export default function(eccent, sinphi) {
  var con;
  if (eccent > 1.0e-7) {
    con = eccent * sinphi;
    return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
  }
  else {
    return (2 * sinphi);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/qsfnz.js
// module id = 20
// module chunks = 4